import { TDealType } from '@cian/api-models/offer-card/v1/get-offer-data';

export const getPriceSubtitle = (dealType: TDealType) => {
  return dealType === 'sale' ? 'Рекомендованная рыночная цена' : 'Рекомендованная арендная ставка';
};
